// 1.0  引入 axios
import axios from 'axios'
import qs from 'qs'
import { Notification, MessageBox, Message } from 'element-ui'
// 测试
// http://zsy.zhongchuang365.com:80
// 线上  http://10.9.136.60:9011
// axios.defaults.baseURL = 'http://zsy.zhongchuang365.com:80'
// 5s无响应提示
axios.defaults.timeout = 30000;
// 3.0 拦截器
// 请求拦截器
axios.interceptors.request.use(config => {
  const token = window.localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = token
  }
  return config
})

// 响应拦截器
axios.interceptors.response.use(res => {
  const code = res.data.code // 未设置状态码则默认成功状态
  // console.log('响应拦截器', res)
  // 获取错误信息
  // const msg = errorCode[code] || res.data.msg || res.data.message || errorCode.default
  if (code === 401) {
    MessageBox.confirm('用户登录状态已过期,请重新登录', '提示', {
      confirmButtonText: '确定',
      // cancelButtonText: '取消',
      showCancelButton:false,
      type: 'warning'
    }).then(() => {
      window.localStorage.clear()
      location.reload()
    }).catch(() => {
      window.localStorage.clear()
      location.reload()
    })
  }else if( code == 504 || code == 502 ){
    Message.error({
      message: '服务器连接异常'
    })
  }
  return res
},
)
// 简单处理一下get和post的方法
export default {
  // baseURL: axios.defaults.baseURL,
  get(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, { params })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          // 处理失败的请求
          reject(err)
        })
    })
  },
  getArr (url, params) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params, paramsSerializer: (params) => qs.stringify(params, { indices: false }), responseType: 'arraybuffer' })
        .then((res) => {
          resolve({ data: res })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // post 请求只能接收  k=v&k=v 的数据格式
  post(url, query, params) {
    console.log(url, query, params);
    return new Promise((resolve, reject) => {
      axios
        .post(url,
          query,
          { params }
        )
        .then(res => {
          resolve(res)
          console.log(res);
        })
        .catch(err => {
          // 处理失败的请求
          reject(err)
          console.log(err);
        })
    })
  },
  postQuery(url, query, params) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
         'Content-Type':'application/x-www-form-urlencoded'
        },
        method: 'post',
        url,
        data: query,
        params: params
      })
        .then((res) => {
          resolve({ data: res })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // blob流格式下载
  // post file 传body
  postQueryFile (url, params, query) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'post',
        responseType: 'arraybuffer',
        url,
        params: query
      })
        .then((res) => {
          resolve({ data: res })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // put 请求，传入参数为数组
  put(url, query) {
    return new Promise((resolve, reject) => {
      axios
        .put(url, query)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  putQuery(url, query, params) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'put',
        url,
        data: query,
        params: params
      })
        .then((res) => {
          resolve({ data: res })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  putType(url, query, params) {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'put',
        url,
        data: query,
        params: params
      })
        .then((res) => {
          resolve({ data: res })
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  // delete请求
  delete(url, query) {
    return new Promise((resolve, reject) => {
      axios
        .delete(url, {
          data: query
        })
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
